import { Injectable } from '@angular/core';
import { AuthService } from '../../auth/auth.service';
import { HttpInterceptor, HttpHandler, HttpEvent, HttpRequest } from '@angular/common/http';
import { Observable} from 'rxjs';
import { LocalStoreService } from '../local-store/local-store.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

	constructor(
		public localStore: LocalStoreService,
		private authService: AuthService
	) { }

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		console.log('Token intercept');
		var token = this.localStore.getToken();
		request = this.addToken(request, token);

		return next.handle(request);
	}

	private addToken(request: HttpRequest<any>, token: string) {
		if (token)
			return request.clone({
				setHeaders: {
					'Authorization': token
				},
				withCredentials: true
			});
		else
			return request.clone({
				withCredentials: true
			});
	}
}
